import React from 'react';
import { useLayout } from '../../../context/LayoutContext';
import '../../../assets/scss/components/wssp/ChatHeader.scss';
import { useWhatsApp } from '../../../context/WhatsAppContext';

const ChatHeader = () => {
  const { theme } = useLayout();
  const { selectedChat } = useWhatsApp();
  
  if (!selectedChat) {
    return (
      <div className={`GM__${theme}-wssp-chat-header GM__${theme}-wssp-chat-header--empty`}>
        <h3>Selecciona un chat para comenzar</h3>
      </div>
    );
  }
  
  return (
    <div className={`GM__${theme}-wssp-chat-header`}>
      <div className={`GM__${theme}-wssp-contact-info`}>
        <div className={`GM__${theme}-wssp-avatar`}>
          {selectedChat.name.charAt(0).toUpperCase()}
        </div>
        <div className={`GM__${theme}-wssp-contact-details`}>
          <h3>{selectedChat.name}</h3>
          <p>{selectedChat.isGroup ? 'Grupo' : 'En línea'}</p>
        </div>
      </div>
      <div className={`GM__${theme}-wssp-header-actions`}>
        <button className={`GM__${theme}-wssp-icon-button`}>🔍</button>
        <button className={`GM__${theme}-wssp-icon-button`}>⋮</button>
      </div>
    </div>
  );
};

export default ChatHeader;